import { render, staticRenderFns } from "./MainImageOrganism.vue?vue&type=template&id=be8a4b48&scoped=true&"
import script from "./MainImageOrganism.vue?vue&type=script&lang=js&"
export * from "./MainImageOrganism.vue?vue&type=script&lang=js&"
import style0 from "./MainImageOrganism.vue?vue&type=style&index=0&id=be8a4b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8a4b48",
  null
  
)

export default component.exports